export enum ChartType {
    LineDottedChart = 1,
    LineChart = 2,
    VerticalLineChart = 3,
    PieChart = 4,
    PieChart3D = 5,
    DottedMultipleValueChart = 6,
    LineMultipleValueChart = 7
}
